import React, { useEffect, useState } from "react";

import { PlusOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";

import GestantesTable from "../../../components/gestantes/table";
import { VerticalContainer } from "../../../components/styled";
import history from "../../../routes/history";
import { getGestantes, deleteGestante } from "../../../services/gestantes";

const { Search } = Input;

export default function ListGestantes() {
  const [filter, setFilter] = useState("");
  const [gestantes, setGestantes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(10);
  const getGestantesPaginated = async () => {
    setLoading(true);
    try {
      const gestantesData = await getGestantes(page, filter);
      setGestantes(gestantesData.data);
      setTotal(gestantesData.total);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getGestantesPaginated();
  }, [page, filter]);

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
  };
  async function confirm(record) {
    await deleteGestante(record.id);
    await getGestantesPaginated();
  }

  const onSearch = (value) => {
    setFilter(value);
  };
  const onChange = (e) => {
    if (!e.target.value) setFilter("");
  };

  return (
    <>
      <VerticalContainer>
        <Search
          onChange={onChange}
          style={{ width: "50%" }}
          placeholder="Pesquisar gestante por paciente..."
          enterButton="Pesquisar"
          onSearch={onSearch}
          size="middle"
        />
        <br />
        <Button
          type="dashed"
          onClick={() => {
            history.push("/adicionar-gestante");
          }}
          style={{ width: "100%!important" }}
          block
        >
          <PlusOutlined />
          Adicionar gestante
        </Button>
        <br />
        <GestantesTable
          loading={loading}
          handleTableChange={handleTableChange}
          gestantes={gestantes}
          total={total}
          confirm={confirm}
        />
      </VerticalContainer>
    </>
  );
}
